module.exports = __webpack_public_path__ + "media/images/pc/specials/common/special_c_30-c8dd9befc4e28256f7954963cdfb5822.jpg";